// extracted by mini-css-extract-plugin
export default {"overrideDeviceCard":"override-device-limitation-card_overrideDeviceCard__0AkNJ"};